import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=2beb51fb&scoped=true"
import script from "./Modify.vue?vue&type=script&lang=js"
export * from "./Modify.vue?vue&type=script&lang=js"
import style0 from "./Modify.vue?vue&type=style&index=0&id=2beb51fb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb51fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2beb51fb')) {
      api.createRecord('2beb51fb', component.options)
    } else {
      api.reload('2beb51fb', component.options)
    }
    module.hot.accept("./Modify.vue?vue&type=template&id=2beb51fb&scoped=true", function () {
      api.rerender('2beb51fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hospital/Modify.vue"
export default component.exports